/* tslint:disable */
/* eslint-disable */
/**
 * Nightingale API
 *  ### Welcome to the Nightingale API !   To use the Nightingale API, you will need a `access_token` from **Bridgetech Support**  ## How to use swagger documentation   Click `Authorize` and paste your  `access_token` as `bearerAuth`  ## Design Notes 1. For non-mandatory fields, the API will allow you to submit `null` *or* omit fields entirely. 2. All query parameters are optional. Pagination fields default as follows: * page = 1 * limit = 20
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetAudits200ResponseMetaLinksInner } from './GetAudits200ResponseMetaLinksInner';
import {
    GetAudits200ResponseMetaLinksInnerFromJSON,
    GetAudits200ResponseMetaLinksInnerFromJSONTyped,
    GetAudits200ResponseMetaLinksInnerToJSON,
    GetAudits200ResponseMetaLinksInnerToJSONTyped,
} from './GetAudits200ResponseMetaLinksInner';

/**
 * 
 * @export
 * @interface GetAudits200ResponseMeta
 */
export interface GetAudits200ResponseMeta {
    /**
     * 
     * @type {number}
     * @memberof GetAudits200ResponseMeta
     */
    current_page: number;
    /**
     * 
     * @type {number}
     * @memberof GetAudits200ResponseMeta
     */
    from: number;
    /**
     * 
     * @type {number}
     * @memberof GetAudits200ResponseMeta
     */
    last_page: number;
    /**
     * 
     * @type {Array<GetAudits200ResponseMetaLinksInner>}
     * @memberof GetAudits200ResponseMeta
     */
    links: Array<GetAudits200ResponseMetaLinksInner>;
    /**
     * 
     * @type {string}
     * @memberof GetAudits200ResponseMeta
     */
    path: string;
    /**
     * 
     * @type {number}
     * @memberof GetAudits200ResponseMeta
     */
    per_page: number;
    /**
     * 
     * @type {number}
     * @memberof GetAudits200ResponseMeta
     */
    to: number;
    /**
     * 
     * @type {number}
     * @memberof GetAudits200ResponseMeta
     */
    total: number;
}

/**
 * Check if a given object implements the GetAudits200ResponseMeta interface.
 */
export function instanceOfGetAudits200ResponseMeta(value: object): value is GetAudits200ResponseMeta {
    if (!('current_page' in value) || value['current_page'] === undefined) return false;
    if (!('from' in value) || value['from'] === undefined) return false;
    if (!('last_page' in value) || value['last_page'] === undefined) return false;
    if (!('links' in value) || value['links'] === undefined) return false;
    if (!('path' in value) || value['path'] === undefined) return false;
    if (!('per_page' in value) || value['per_page'] === undefined) return false;
    if (!('to' in value) || value['to'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    return true;
}

export function GetAudits200ResponseMetaFromJSON(json: any): GetAudits200ResponseMeta {
    return GetAudits200ResponseMetaFromJSONTyped(json, false);
}

export function GetAudits200ResponseMetaFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAudits200ResponseMeta {
    if (json == null) {
        return json;
    }
    return {
        
        'current_page': json['current_page'],
        'from': json['from'],
        'last_page': json['last_page'],
        'links': ((json['links'] as Array<any>).map(GetAudits200ResponseMetaLinksInnerFromJSON)),
        'path': json['path'],
        'per_page': json['per_page'],
        'to': json['to'],
        'total': json['total'],
    };
}

export function GetAudits200ResponseMetaToJSON(json: any): GetAudits200ResponseMeta {
    return GetAudits200ResponseMetaToJSONTyped(json, false);
}

export function GetAudits200ResponseMetaToJSONTyped(value?: GetAudits200ResponseMeta | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'current_page': value['current_page'],
        'from': value['from'],
        'last_page': value['last_page'],
        'links': ((value['links'] as Array<any>).map(GetAudits200ResponseMetaLinksInnerToJSON)),
        'path': value['path'],
        'per_page': value['per_page'],
        'to': value['to'],
        'total': value['total'],
    };
}

